module.exports = "/img/banner-m.139b75f2.png";